import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Divider,
} from "@mui/material";
import typographyStyles from "../../../theme/Typography";
import BasicButtons from "../../../components/Button";
import Dropdown from "../../../components/Dropdown";
import InputField from "../../../components/InputField";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { addNewCategorySchema, addWorkoutSchema } from "../../../schema";
import backBtn from "../../../assets/backBtn.svg";

import "../../../scss/main.css";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
	ClassicEditor,
	AccessibilityHelp,
	Alignment,
	Autoformat,
	AutoLink,
	Autosave,
	BlockQuote,
	Bold,
	CodeBlock,
	Essentials,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	GeneralHtmlSupport,
	Heading,
	HorizontalLine,
	Indent,
	IndentBlock,
	Italic,
	Link,
	Paragraph,
	SelectAll,
	Style,
	Table,
	TableCaption,
	TableCellProperties,
	TableColumnResize,
	TableProperties,
	TableToolbar,
	TextTransformation,
	Underline,
	Undo
} from 'ckeditor5';
import {
  getCategoryWithToken,
  getDataHandlerWithToken,
  postDataHandlerWithToken,
} from "../../../apiconfig/service";
import toast from "react-hot-toast";
import MultiSelectDropdown from "../../../components/MultiSelectDropdown";


const addEditStyle = {
  addEditTitle: {
    ...typographyStyles.h4,
  },

  addEditLabel: {
    ...typographyStyles.h6,
  },

  radioContainer: {
    display: "flex",
  },

  // imagePreview: {
  //     marginTop: '10px',
  //     objectFit: 'cover',
  //     border: '2px solid gray',
  // }
};

const dropdownOptions = [
  "Trying to Conceive",
  "Pregnant",
  "Postpartum (0-6 Weeks After Birth)",
  "Beyond -(6 Weeks + After Birth (Weeks, months, Years))",
  "Babies and Kids", 
];

const se = [
  { key: "Trying to Conceive", value: "TRYINGTOCONCEIVE" },
  { key: "Pregnant", value: "PREGNANT" },
  { key: "Postpartum (0-6 Weeks After Birth)", value: "POSTPARTUM" },
  {
    key: "Beyond -(6 Weeks + After Birth (Weeks, months, Years))",
    value: "BEYOND",
  },
  { key: "Babies and Kids", value: "BABIESANDKIDS" }, // New object added
];


const EditWorkout = () => {
  const [selectedValue, setSelectedValue] = useState("Select stage");
  const [categoryType, setCategoryType] = useState("FREE");
  const [thumbnail, setThumbnail] = useState(null);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  // const [thumbnailPreview, setThumbnailPreview] = useState(null);

  const handleDropdownChange = (value) => {
    setSelectedValue(value);
  };

  const handleCategoryTypeChange = (event) => {
    setCategoryType(event.target.value);
  };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    setThumbnail(file);
    // setThumbnailPreview(URL.createObjectURL(file));
  };

  const initialValues = {
    selectStage: [],
    workoutCategoryName: "",
    // categoryImage: null,
  };

  const navigate = useNavigate();

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: addWorkoutSchema,
    onSubmit: async () => {
      console.log(values);
      try {
        setLoading(true);
        const res = await postDataHandlerWithToken("addUpdateWorkoutCategory", {
          workoutCategoryId: id,
          stage:values.selectStage,
          workoutCategoryName: values.workoutCategoryName,
          saveAs: categoryType,
          // thumbnail: thumbnail,
        });
        if (res.responseCode === 200) {
          toast.success(res.responseMessage);
          console.log(res);
          navigate("/workoutlisting");
        } else {
          // Handle errors
          toast.error(res.data.responseMessage);
          console.error(res);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    const fetchWorkoutCategory = async () => {
      try {
        const result = await getCategoryWithToken("viewWorkoutCategory", {
          categoryId:id
        });
        if (result.responseCode === 200) {
          // console.log(result.result);
          // toast.success(result.responseMessage);

          const categoryData = result.result;
          setValues({
            selectStage: categoryData.stage,
            workoutCategoryName: categoryData.workoutCategoryName,
          });
          setCategoryType(categoryData.saveAs);
          setSelectedValue(categoryData.stage);
          //   setCategoryType(categoryData.saveAs);
        } else {
          //   toast.error(result.responseMessage);
          console.log(result);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchWorkoutCategory();
  }, [id, setValues]);
  const [editorContent, setEditorContent] = useState("");

  return (
    <DashboardLayout
      sectionName="Workout Management - Category"
      title="Edit Workout Category"
    >
      <Box className="heading-container-top">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Box>
            <img
              src={backBtn}
              alt="backBtn"
              style={{
                // // width: "2.813",
                // height: "5.813",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            />
          </Box>
          <Typography sx={{ ...typographyStyles.h4 }}>Edit Workout Section</Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="add-edit-container">
        <form className="add-edit-content-section" onSubmit={handleSubmit}>
          <Box className="add-edit-content">
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Select Stage:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
              <MultiSelectDropdown
                  name="selectStage"
                  onBlur={handleBlur}
                  sx={addEditStyle.categoryInputField}
                  options={se}
                  value={values.selectStage}
                  placeholder="Select stage"
                  onChange={(value) =>
                    handleChange({ target: { name: "selectStage", value } })
                  }
                />
                {errors.selectStage && touched.selectStage ? (
                  <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                    {errors.selectStage}
                  </p>
                ) : null}
              </Box>
            </Box>
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Workout Section Name:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <InputField
                  type="text"
                  name="workoutCategoryName"
                  value={values.workoutCategoryName}
                  maxLength={30}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter section name"
                />
                {errors.workoutCategoryName && touched.workoutCategoryName ? (
                  <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                    {errors.workoutCategoryName}
                  </p>
                ) : null}
              </Box>
            </Box>
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>Save as:</Typography>
              </Box>
              <Box className="add-edit-input-field">
                <FormControl component="fieldset">
                  <RadioGroup
                    name="categoryType"
                    value={categoryType}
                    onChange={handleCategoryTypeChange}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <FormControlLabel
                     className="radio"
                      value="FREE"
                      control={<Radio />}
                      label="Free"
                    />
                    <FormControlLabel
                     className="radio"
                      value="LOCKED"
                      control={<Radio />}
                      label="Locked (will be accessed after subscription)"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
          </Box>
          <Box className="add-edit-button-section" sx={{ alignItems: "center", justifyContent: "center" }}>
            <BasicButtons
              text="Update Workout Section"
              name="submit"
              type="submit"
              width={"30%"}
              loading={loading}
            />
           
          </Box>
        </form>
      </Box>
    </DashboardLayout>
  );
};

export default EditWorkout;
